import { Async, toAsyncFetched } from '@client/new/helpers/types';
import { useCommunityUserEmailModel } from '../model/communityUser.model';

export type UserEmailModalState = {
  email: string | null;
  allowEmails: boolean | null;
  isUnavailable: boolean;
  fallbackUsed: boolean;
};

export const useUserEmailModalViewModel = ({
  userId,
  fallbackEmail,
  enabled,
}: {
  userId?: number;
  fallbackEmail?: string | null;
  enabled: boolean;
}): Async<UserEmailModalState> => {
  const emailModel = useCommunityUserEmailModel(userId, enabled);

  if (emailModel.type !== 'fetched') {
    return emailModel;
  }

  const preferredEmail = emailModel.value.email;
  const email = preferredEmail || fallbackEmail || null;
  const allowEmails = emailModel.value.allowEmails;
  const isUnavailable = !email;
  const fallbackUsed = !preferredEmail && Boolean(fallbackEmail);

  return toAsyncFetched({
    email,
    allowEmails,
    isUnavailable,
    fallbackUsed,
  });
};
